export { default as ComingSoon } from "./ComingSoon"
